import { FilterTypeOption, Sort } from "@evergis/ui";
import { AttributeType } from "@evergis/api";

import { TableFilterState } from "../../modules/Table/types";
import { FeatureDcExtended } from "../selectFeatures/types";

export enum TableSelectionMode {
  None = "none",
  All = "all",
}

export interface TableSelection {
  mode?: TableSelectionMode;
  processedRows?: (number | string)[];
  totalRows?: number;
}

export interface TableSpecialFilter {
  active?: boolean;
  layerName?: string;
  attribute?: string;
  attributeType?: AttributeType;
  filterType?: FilterTypeOption | null;
  tableFilterCondition?: string;
  selection?: [number, number];
}

export interface TableState {
  layerId?: string;
  queryData?: Record<string, unknown>[];
  isFilteringMap?: Record<string, boolean>;
  tableFilters?: Record<string, TableFilterState>;
  tableFilterConditions?: Record<string, string>;
  tableSelection?: Record<string, TableSelection>;
  tableSort?: Record<string, Sort>;
  specialFilter?: TableSpecialFilter;
  selectedFeature?: FeatureDcExtended;
}
